export enum VisualsDashboardWidgetSizingEnum {
    SMALL = 'SMALL',
    MEDIUM_ROW = 'MEDIUM_ROW',
    LARGE_ROW = 'LARGE_ROW',
}
